import React, { useContext, useEffect, useState } from 'react'
import { Select, DatePicker } from 'antd'

import { getAllCityApi } from '../../api/city'
import {
    listOfResponsable,
    getAllVehicul
} from "../../api/data/Vehiculs";

import { Button } from 'reactstrap'
import { Link } from 'react-router-dom';

import { HeaderContext } from './../../context/headerContext'

const { Option } = Select;
const { RangePicker } = DatePicker;

function Header() {
    const { setSelectedCitiesContext, setSelectedDateContext, setSelectedFiltersContext } = useContext(HeaderContext);

    const [cityData, setCityData] = useState([])
    const [vehiculesData, setVehiculesData] = useState([])
    const [responsablesData, setResponsablesData] = useState([])
    const [selectedCities, setSelectedCities] = useState({
        startCityName: '',
        arrivedCityName: ''
    })
    const [selectedFilters, setSelectedFilters] = useState({
        selectedModele: '',
        selectedConducteur: ''
    })

    useEffect(() => {
        getAllInitialData()
        // eslint-disable-next-line
    }, [])

    const getAllInitialData = async () => {
        try {
            const vehicules = await getAllVehicul()
            setVehiculesData(Array.isArray(vehicules) ? vehicules : [])
        }
        catch(err) {
            setVehiculesData([])
        }

        try {
            const responsables = await listOfResponsable()
            setResponsablesData(Array.isArray(responsables) ? responsables : [])
        }
        catch(err) {
            setResponsablesData([])
        }

        try {
            const cityRes = await getAllCityApi()
            setCityData(Array.isArray(cityRes) ? cityRes : [])
        }
        catch(err) {
            setCityData([])
        }
    }

    const handleFilterChange = async (value, key) => {
        if(key) {
            setSelectedFilters({...selectedFilters, [key?.key?.split('_')[0]]: value})
            setSelectedFiltersContext({...selectedFilters, [key?.key?.split('_')[0]]: value})
        }
        if(!key) {
            setSelectedFilters({
                selectedModele: '',
                selectedConducteur: ''
            })
            setSelectedFiltersContext({
                selectedModele: 'All',
                selectedConducteur: 'All'
            })
        }
    }

    const handleSelectChange = (value, key) => {
        if(key) {
            setSelectedCities({...selectedCities, [key?.key?.split('_')[0]]: value})
            setSelectedCitiesContext({...selectedCities, [key?.key?.split('_')[0]]: value})
        }
        if(!key) {
            setSelectedCities({
                startCityName: '',
                arrivedCityName: ''
            })
            setSelectedCitiesContext({
                startCityName: 'All',
                arrivedCityName: 'All'
            })
        }
    }
    const handleDateChange = (value, date) => {
        setSelectedDateContext({
            SelectedFromDate: date[0],
            SelectedToDate: date[1]
        })
    }

  return (
    <section className='headerComponent'>
        <div className='headerTop'>
            <div>
                <span className='eyebrow'>Gestion des opérations</span>
                <h1>Trajets</h1>
            </div>
            <Link to="/admin/NewGestionOP">
                <Button className='createButton'>+ Créer un envoi</Button>
            </Link>
        </div>

        <div className='filterToolbar'>
            <div className='filterField'>
                <label>Modèle</label>
                <Select
                    showSearch
                    allowClear
                    placeholder="Tous les modèles"
                    optionFilterProp="children"
                    onChange={handleFilterChange}
                    style={{ width: '100%' }}
                >
                    {vehiculesData.map((el) => (
                        <Option key={`selectedModele_${el._id}`} value={el._id}>{el.marque}</Option>
                    ))}
                </Select>
            </div>

            <div className='filterField'>
                <label>Conducteur</label>
                <Select
                    showSearch
                    allowClear
                    placeholder="Tous les conducteurs"
                    optionFilterProp="children"
                    onChange={handleFilterChange}
                    style={{ width: '100%' }}
                >
                    {responsablesData.map((el) => (
                        <Option key={`selectedConducteur_${el._id}`} value={el._id}>{el.firstName} {el.lastName}</Option>
                    ))}
                </Select>
            </div>

            <div className='filterField'>
                <label>Ville de départ</label>
                <Select
                    showSearch
                    allowClear
                    placeholder="Toutes les villes"
                    optionFilterProp="children"
                    onChange={handleSelectChange}
                    filterOption={(input, option) =>
                        option?.key?.split('_')[1]?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
                    }
                    style={{ width: '100%' }}
                >
                    {cityData.map((el) => (
                        <Option key={`startCityName_${el.ville}`} value={el.ville}>{el.ville}</Option>
                    ))}
                </Select>
            </div>

            <div className='filterField'>
                <label>Ville d'arrivée</label>
                <Select
                    showSearch
                    allowClear
                    placeholder="Toutes les villes"
                    optionFilterProp="children"
                    onChange={handleSelectChange}
                    filterOption={(input, option) =>
                        option?.key?.split('_')[1]?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
                    }
                    style={{ width: '100%' }}
                >
                    {cityData.map((el) => (
                        <Option key={`arrivedCityName_${el.ville}`} value={el.ville}>{el.ville}</Option>
                    ))}
                </Select>
            </div>

            <div className='filterField'>
                <label>Période</label>
                <RangePicker onChange={handleDateChange} placeholder={['Du', 'Au']} style={{ width: '100%' }} />
            </div>
        </div>
    </section>
  )
}

export default Header
